import { ENVS } from '@constants/envs';
import { ENV } from '@constants/general';

/**
 * Check if the app is running in a staging environment
 */
export const isStaging = (): boolean => globalThis.location?.hostname?.indexOf('app-staging') >= 0;

/**
 * Check if the app is running in a test environment
 */
export const isTest = (): boolean => globalThis.location?.hostname?.indexOf('app-test') === 0;

/**
 * Check if the app is running in a dev environment
 */
export const isDev = (): boolean => ENV === ENVS.DEV && !isTest();

/**
 * Check if the app is running in a local environment
 */
export const isLocal = (): boolean => ENV === ENVS.LOCAL;

/**
 * Check if the app is running in a production environment
 */
export const isProduction = (): boolean => ENV === ENVS.PRODUCTION && !isStaging();
